import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Beatloader from '../../../../Common/Loaders/Beatloader';
import { toast } from 'react-toastify';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import BasicInfoEdit from './LedgerAccountEdit/BasicInfoEdit';
import AddressEdit from './LedgerAccountEdit/AddressEdit';
import TaxDetailsEdit from './LedgerAccountEdit/TaxDetailsEdit';
import BankDetailsEdit from './LedgerAccountEdit/BankDetailsEdit';
import ContactInfoEdit from './LedgerAccountEdit/ContactInfoEdit';

const LedgerAccountEdit = ({
    loadingLedgerAccountDetail,
    LedgerAccountDetail,
    LedgerAccountDetailError,
    showLedgerDetail,
    handleCloseLedgerDetail,
    refreshLedger
}) => {
    if (loadingLedgerAccountDetail) { return <Beatloader /> }
    if (LedgerAccountDetailError) {
        toast.error(LedgerAccountDetailError)
    }
    // console.log("LedgerAccountDetail", LedgerAccountDetail)
    if (LedgerAccountDetail && Object.keys(LedgerAccountDetail).length) {
        return (
            <>
                <Modal
                    size="xl"
                    show={showLedgerDetail}
                    onHide={handleCloseLedgerDetail}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{LedgerAccountDetail ? LedgerAccountDetail.ledger_party_name ?? "" : ""}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Tabs
                            defaultActiveKey="basic"
                            id="uncontrolled-tab-example"
                            className="mb-3"
                        >
                            <Tab eventKey="basic" title="Basic Info">
                                <BasicInfoEdit LedgerAccountDetail={LedgerAccountDetail} refreshLedger={refreshLedger} />
                            </Tab>
                            <Tab eventKey="address" title="Address">
                                <AddressEdit LedgerAccountDetail={LedgerAccountDetail} refreshLedger={refreshLedger} />
                            </Tab>

                            <Tab eventKey="tax" title="Tax Details">
                                <TaxDetailsEdit LedgerAccountDetail={LedgerAccountDetail} refreshLedger={refreshLedger} />
                            </Tab>

                            <Tab eventKey="bank" title="Bank Details">
                                <BankDetailsEdit LedgerAccountDetail={LedgerAccountDetail} />
                            </Tab>

                            <Tab eventKey="contact" title="Contact Info">
                                <ContactInfoEdit LedgerAccountDetail={LedgerAccountDetail} refreshLedger={refreshLedger} />
                            </Tab>
                        </Tabs>
                    </Modal.Body>
                </Modal>
            </>
        )
    }
}

export default LedgerAccountEdit